import { useEffect, useState } from "react";
import { fmtDuration } from "@/lib/format";

// Live-ticking seconds remaining until an ISO expiry timestamp.
export const useCountdown = (expiryIso) => {
  const calc = () => (expiryIso ? Math.max(Math.floor((new Date(expiryIso) - Date.now()) / 1000), 0) : null);
  const [secs, setSecs] = useState(calc);
  useEffect(() => {
    setSecs(calc());
    if (!expiryIso) return;
    const t = setInterval(() => setSecs(calc()), 1000);
    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expiryIso]);
  return secs;
};

const DAY = 18 * 3600;

export const TokenCountdown = ({ expiry, testid, bar = false }) => {
  const secs = useCountdown(expiry);
  if (secs === null) return null;
  const tone = secs <= 0 ? "rose" : secs < 1800 ? "rose" : secs < 7200 ? "amber" : "emerald";
  const color = { emerald: "text-emerald-400", amber: "text-amber-400", rose: "text-rose-400" }[tone];
  const bg = { emerald: "bg-emerald-500", amber: "bg-amber-500", rose: "bg-rose-500" }[tone];
  if (!bar) {
    return <span data-testid={testid} className={`num text-[11px] font-semibold ${color}`}>{fmtDuration(secs)}</span>;
  }
  return (
    <div data-testid={testid} className="space-y-1">
      <div className="flex items-center justify-between">
        <span className="text-[10px] uppercase tracking-wider text-slate-500">Token expires in</span>
        <span className={`num text-sm font-semibold ${color}`}>{fmtDuration(secs)}</span>
      </div>
      <div className="h-1.5 w-full overflow-hidden rounded-full bg-slate-800">
        <div className={`h-full ${bg} transition-all`} style={{ width: `${Math.min(100, (secs / DAY) * 100)}%` }} />
      </div>
    </div>
  );
};
